import { Form } from "antd";
import { OptList } from "./Model";
import { TitleBar } from "./Model";
const CheckboxList = (props) => {
  const handleCheck = (item) => {
    const { value = [], onChange } = props;
    const _value = [...value];
    let index = _value.findIndex((o) => o.position.toString() === item.position.toString());
    if (index >= 0) {
      let item = value[index];
      _value.splice(index, 1, { ...item, checked: !item.checked });
    } else {
      _value.push({ answerId: item.id, position: item.position, checked: true, source: item });
    }
    onChange(_value);
  };
  return <OptList {...props} type="checkbox" onCheck={handleCheck}></OptList>;
};

const CheckboxViews = (props) => {
  const { info } = props;
  return (
    <div className="components-input-views">
      <TitleBar info={info}></TitleBar>
      <div className="opt-list radio-list">
        <Form.Item name={["postAnswer", info.position]}>
          <CheckboxList list={info.answerList} info={info}></CheckboxList>
        </Form.Item>
      </div>
    </div>
  );
};

export default CheckboxViews;
